
<iframe [style.height]="innerHeight" id="CancellationsApprovalIframe" style="width: 100%;" [src]="cancellationsApprovalUrl | safe" title="Cancellations Approval"></iframe>
